@if (editable()) {
  <!--
    stitch-app-shell FormKit: the meeting link is a field like Location, always ready to type into (Johanna,
    2026-10-21: was a read line behind a pencil), with the prototype's video glyph. Once it holds an http(s) link,
    "Join meeting ↗" beside it, a secondary button as tall as the field, opens it in a new tab (Johanna, 2026-10-21).
  -->
  <div class="flex min-w-0 items-center gap-2">
    <app-input
      class="min-w-0 flex-1"
      appearance="sapphire-outline"
      size="s"
      placeholder="Add a meeting link"
      ariaLabel="Meeting link"
      leadingIcon="sapphire-video"
      [inputFormControl]="control()"
      [withClear]="true"
      [withErrors]="false"
    />
    @if (href(); as href) {
      <a
        class="flex h-18 shrink-0 items-center gap-2 rounded-md border border-gray-200 bg-white pl-6 pr-4 text-base font-medium text-gray-700 transition-colors hover:bg-gray-100 focus-visible:border-primary-600 focus-visible:outline-2 focus-visible:outline-primary-300"
        target="_blank"
        rel="noopener noreferrer"
        [href]="href"
      >
        Join meeting
        <app-icon class="text-gray-500" name="sapphire-arrow-up-right" [size]="16" />
      </a>
    }
  </div>
} @else {
  <!-- An invitation's link, which only its organizer may change: a link to open. -->
  <div class="flex h-[32px] min-w-0 items-center text-sm text-gray-950">
    @if (href(); as href) {
      <app-link
        class="min-w-0 max-w-full [&>a]:min-w-0 [&>a]:max-w-full"
        type="external"
        target="_blank"
        size="s"
        [href]="href"
      >
        <span class="truncate" [attr.title]="text()">{{ text() }}</span>
      </app-link>
    } @else if (text()) {
      <span class="truncate" [attr.title]="text()">{{ text() }}</span>
    } @else {
      <span class="text-subdued">No meeting link</span>
    }
  </div>
}
